export const APP_VERSION = '1.0.0';
// @ts-ignore
window.APP_VERSION = APP_VERSION;
